var map = {
	"./crud.png": "aa12",
	"./default.png": "5686",
	"./jsonplaceholder.png": "a115",
	"./lacasadelasflores.png": "0cb8",
	"./marvel-api.png": "ddab",
	"./movie.png": "5efe",
	"./perfilador.png": "1e85",
	"./snake.png": "352e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc1f";